export const COLLAPSED_EVENT_COUNT = 4;
export const SECONDS_PER_HOUR = 3600;
export const SECONDS_PER_MINUTE = 60;
export const RATE_TIME_FORMAT = 'hh : mm : ss A';
export const RATE_TIME_PLACEHOLDER = '-- : -- : -- --';

export const DURATION_TIME_UNITS = [
  { key: 'hours', label: 'h', step: SECONDS_PER_HOUR },
  { key: 'minutes', label: 'm', step: SECONDS_PER_MINUTE },
  { key: 'seconds', label: 's', step: 1 },
] as const;
